<template>
  <div class="w-100 h-100">
    <vue-apex-charts
      :ref="`simple-donut-${name}`"
      :key="`${series.length}${options.length}`"
      type="donut"
      :height="height"
      :options="options"
      :series="series"
    />
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'DonutChartSimplified',
  components: {
    VueApexCharts,
  },
  props: {
    name: {
      type: String,
      default: '',
    },
    data: {
      type: Array,
      default: () => [],
    },
    height: {
      type: String,
      default: '350',
    },
  },
  data() {
    return {
      colors: [
        '#36B37E',
        '#1D79F2',
        '#E34850',
        '#FFAB00',
        '#141A32',
        '#AD6529',
        '#E96D73',
        '#FFCD66',
        '#43485B',
        '#6E6E6E',
        '#CACACA',
        '#81C4AE',
      ],
    }
  },
  computed: {
    series() {
      return this.data.map(el => el.count)
    },
    options() {
      return {
        chart: {
          height: 365,
          type: 'donut',
          width: '100%',
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif',
        },
        fill: {
          opacity: 0.95,
        },
        colors: this.colors,
        plotOptions: {
          bar: {
            columnWidth: '45%',
            distributed: true,
          },
        },
        legend: {
          show: true,
          position: 'bottom',
        },
        labels: this.data.map(el => el.name),
        tooltip: {
          y: {
            formatter(value) {
              return value.toLocaleString()
            },
          },
        },
        noData: {
          text: 'No data available',
          align: 'center',
          verticalAlign: 'middle',
          offsetX: 0,
          offsetY: 0,
          style: {
            fontSize: '14px',
          },
        },
        responsive: [
          {
            breakpoint: 990,
            options: {
              plotOptions: {
                bar: {
                  horizontal: false,
                },
              },
            },
          },
        ],

      }
    },
  },
}
</script>
